import { platMultiNet, runnerMultiNet, platbaseNet } from '../instance/nets'
import { platUrl } from '../instance/generator'

export function aaa(params) {
    return platMultiNet.post('http://cars-tool-server.guazi-apps.com/getStatus?status=200&time=1000', params)
}
export function getQuestionList(params) {
    return platMultiNet.get('/api/question/page', { params })
}
export function getQuestionInfo(params) {
    return platMultiNet.get(`/api/question/page/${params.pageId}`, { params })
}
export function getQuestionDetail(params) {
    return platMultiNet.get(`/api/question/page/detail/${params.pageId}`, { params })
}
export function questionCreate(data) {
    return platMultiNet.post(`/api/question/page?tid=${data.tid}`, data)
}
export function questionEdit(data) {
    return platMultiNet.put(`/api/question/page?tid=${data.tid}`, data)
}
export function questionDelete(data) {
    return platMultiNet.delete(`/api/question/page/${data.pageId}?tid=${data.tid}`, { data })
}
export function questionValid(data) {
    return platMultiNet.post(`/api/question/page/valid?tid=${data.tid}`, data)
}
export function questionPublish(data) {
    return platMultiNet.post(`/api/question/page/publish?tid=${data.tid}`, data)
}
export function questionStop(data) {
    return platMultiNet.put(`/api/question/page/suspend?tid=${data.tid}`, data)
}
export function getQuestionConfig(params) {
    return platMultiNet.get(`/api/question/config/${params.pageId}`, { params })
}
export function getAuthority(params) {
    return platMultiNet.get(`/api/question/config/authority/${params.pageId}?tid=${params.tid}`)
}
export function questionConfig(data) {
    return platMultiNet.post(`/api/question/config?tid=${data.tid}`, data)
}
export function questionCopy(data) {
    return platMultiNet.post(`/api/question/page/copy?tid=${data.tid}`, data)
}
export function questionShare(params) {
    return platMultiNet.get('/api/question/page/share', { params })
}
export function getTopicType(params) {
    return platMultiNet.get('/api/topic/class/question', { params })
}
export function topicSave(data) {
    return platMultiNet.post(`/api/topic/item/detail/save?tid=${data.tid}`, data)
}
export function topicInfo(params) {
    return platMultiNet.get(`/api/topic/item/detail/info/${params.topicId}`, { params })
}
export function topicClone(data) {
    return platMultiNet.post(`/api/topic/clone?tid=${data.tid}`, data)
}
export function topicMove(data) {
    return platMultiNet.post(`/api/topic/move?tid=${data.tid}`, data)
}
export function topicDelete(data) {
    return platMultiNet.delete(`/api/topic/${data.topicId}?tid=${data.tid}`, data)
}

export function getStatisticTopic(params) {
    return platMultiNet.get(`/api/question/statistic/topic/${params.pageId}`, { params })
}
export function exportStatisticTopic(params) {
    return platMultiNet.get(`/api/question/statistic/answer/export/${params.pageId}`, { params })
}
export function getRuntimeIndex(params) {
    return platMultiNet.get(`/api/question/page/preview/${params.pageId}`, { params })
}
export function getRuntimeInit(params) {
    return runnerMultiNet.get(`/api/question/runner/init/${params.pageId}`, { params })
}
export function getRuntimeAnoInit(params) {
    return runnerMultiNet.get(`/pub/question/runner/init/${params.pageId}`, { params })
}
export function getRuntimeSave(data) {
    return runnerMultiNet.post(`/api/question/runner/save?tid=${data.tid}`, data)
}
export function getRuntimeAnoSave(data) {
    return runnerMultiNet.post(`/pub/question/runner/save?tid=${data.tid}`, data)
}
export function getLoginType(params) {
    return runnerMultiNet.get(`/pub/question/runner/check/${params.pageId}`, { params })
}
export function setSkip(data) {
    return platMultiNet.post(`/api/topic/item/detail/save?tid=${data.tid}`, data)
}
export function batchLabel(params) {
    return platMultiNet.get('/api/topic/item/default', { params })
}
export function saveShowJson(data) {
    return platMultiNet.post(`/api/topic/item/detail-ext/save?tid=${data.tid}`, data)
}
export function updateShowJson(data) {
    return platMultiNet.post(`/api/topic/item/detail-ext/batch?tid=${data.tid}`, data)
}
// 校验问卷是否有发短信权限
export function checkNotice(params) {
    return platMultiNet.get('/api/question/permission/check', { params })
}
// 申请添加通知入口的权限
export function applyNotice(params) {
    return platMultiNet.post(`/api/question/permission/add?tid=${params.tid}`, params)
}
// 导入待发送人员列表
export function importCustomer(params, tid) {
    return platMultiNet.post(`/api/question/message/import/customer?tid=${tid}`, params)
}
// 导出待发送人员模板文件
export function exportCustomer(params) {
    return `${platUrl}/pub/message/import/template?tid=${params.tid}`
}
// 根据问卷获取答卷进度统计
export function statistic(params) {
    return platMultiNet.get('/api/question/message/send/statistic', { params })
}
// 根据问卷获取答卷发送记录接口（分页）
export function sendList(params) {
    return platMultiNet.get('/api/question/message/send/list', { params })
}
// 导出当前问卷的答卷进度
export function exportProcess(params) {
    return `${platUrl}/pub/message/send/export/${params.batchNo}?tid=${params.tid}`
}
// 批量重新发送消息
export function retry(params) {
    return platMultiNet.post(`/api/question/message/send/retry?tid=${params.tid}`, params)
}
// 埋点
export function tracking(params) {
    return runnerMultiNet.post(`/pub/question/runner/tracking?tid=${params.tid}`, params)
}
// 转移
export function transfer(params) {
    return platMultiNet.post(`/api/question/page/transfer?tid=${params.tid}`, params)
}
// 选项图片上传
export function upload(params, tid) {
    return platMultiNet.post(`/api/file/upload?tid=${tid}`, params)
}

// 短信签名
export function getSignType(params) {
    return platMultiNet.get('/api/question/config/sign', { params })
}

// 查询部门（返回结果只返回前5条）
export function getDepts(params) {
    return platbaseNet.get('/eim-platbase/api/depts', { params })
}

// 查询人员信息
export function getUser(params) {
    return platbaseNet.get('/eim-platbase/api/user', { params })
}

// 获取职级基础数据
export function getRank(params) {
    return platMultiNet.get('/api/question/basic/rank/list', { params })
}

// 保存更新问卷发送范围设置
export function publishSave(params, tid) {
    return platMultiNet.post(`/api/question/config/publish/save?tid=${tid}`, params)
}

export function getInternal(params, tid) {
    return platMultiNet.post(`/api/question/message/send/user/internal?tid=${tid}`, params)
}

// 问卷首页
export function getData(params) {
    return platMultiNet.get('/api/question/page/home', { params })
}
// 模板列表
export function templateList(params) {
    return platMultiNet.get('/api/template/pageQuery', { params })
}
// 模板详情
export function getTemplateDetail(params) {
    return platMultiNet.get('/api/template/detail', { params })
}
// 使用此模板
export function useTemplate(params) {
    return platMultiNet.post(`/api/template/useThisTemplate?tid=${params.tid}`, params)
}
// 另存为
export function saveTemplate(params) {
    return platMultiNet.post(`/api/template/saveAsTemplate?tid=${params.tid}`, params)
}

// 查看模版中的标签
export function getTemplateLabel(params) {
    return platMultiNet.get('/api/template/label/list', { params })
}
// 删除模版接口
export function deleteTemplate(params) {
    return platMultiNet.post(`/api/template/deleteTemplate?tid=${params.tid}`, params)
}
// 查询模版设置
export function queryConfig(params) {
    return platMultiNet.get('/api/template/queryConfig', { params })
}
// 模版编辑保存
export function editTemplate(data) {
    return platMultiNet.post(`/api/template/editTemplate?tid=${data.tid}`, data)
}
// 批量增加员工
export function getEmailPrefixList(data) {
    return platbaseNet.post(`/eim-platbase/api/user/email-prefix-list?tid=${data.tid}`, data)
}

